<!-- TEMPLATE -->
<template>
  <div class="wrapper">
    <dean-dialog
        :title="title"
        :small="true"
    >
      <slot><!--Slot for load overlay-->

      </slot>
      <dean-notification :is-modal="true">

      </dean-notification>

      <dean-form-row v-if="blocking" id="blockReason" :label="text" v-model="blockReason"></dean-form-row>
      <p v-else>{{text}}</p>
      <span slot="dean-dialog-button-group">
        <dean-button :danger="true" :dialog-button="true" @click.native="close()">Nee</dean-button>
        <dean-button :success="true" :dialog-button="true" @click.native="doYesClick()">Ja</dean-button>
      </span>
    </dean-dialog>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
  import Vue from 'vue';
  import {Component, Prop} from 'vue-property-decorator';
  import axios from 'axios';
  import {deanDialog, deanDialogButtonGroup, warningIcon} from '@deanone/dean-components';
  import deanButton from '@/components/deanComponents/deanButton.vue';
  import DeanNotification from '@/components/deanComponents/deanNotification.vue';
  import deanFormRow from '@/components/deanComponents/deanFormRow.vue';
  import {deanDialogBus} from '@/main';

  @Component({
    components: {
      warningIcon,
      DeanNotification,
      deanDialog,
      deanButton,
      deanFormRow,
      deanDialogButtonGroup,
    },
  })

  export default class BlockPartnerDialog extends Vue {
    // DATA
    @Prop() public payloadData!: {
      // name: string
      // params: object
      [key: string]: any,
    };
    public data: { [key: string]: any } = {};
    public blocking: boolean = true;
    public urlParams: string = '';
    public blockReason: string = '';

    // COMPUTED
    get title() {
      return this.payloadData.name + (this.blocking ? ' blokkeren?' : ' deblokkeren?');
    }

    get text() {
      return this.blocking ? ' Reden van blokkade' :
        'Weet u zeker dat u ' + this.payloadData.name + ' wilt deblokkeren';
    }

    // METHODS
    public close() {
      deanDialogBus.$emit('close');
    }

    public doYesClick() {
      this.$emit('setLoad', true);

      let method;
      if (this.blocking) {
        method = this.blockPerson();
      } else {
        method = this.unblockPerson();
      }
      const action = this.blocking ? 'geblokkeerd' : 'gedeblokkeerd';
      method.then(
          (response) => {
            deanDialogBus.$emit('personBlock', action);
            this.close();
          },
          (error) => {
            this.$toast({
              text: `Er kan momenteel niet worden ${action}, probeer het later opnieuw.`,
              theme: 'warning',
              icon: warningIcon,
            });
          },
      ).finally(() => {
        this.$emit('setLoad', false);
      });
    }

    public blockPerson() {
      return axios.post('/-/trade/api/partner.suspend', {
        id: this.payloadData.params.id,
      });
    }

    public unblockPerson() {
      return axios.post('/-/trade/api/partner.unsuspend', {
        id: this.payloadData.params.id,
      });
    }

    public created() {
      if (this.payloadData.blocking !== undefined) {
        this.blocking = this.payloadData.blocking;
      }
    }

    public destroyed() {
      this.$emit('setLoad', false);
    }
  }
</script>

<!-- STYLE -->
<style lang="scss" scoped>
  // IMPORT
  @import '~@deanone/dean-components/src/scss/vars';
</style>
